import { Component, EventEmitter, Input, Output } from '@angular/core';
import { debounceTime, Subject } from 'rxjs';

@Component({
  selector: 'shared-search-input-dropdown',
  templateUrl: './search-input-dropdown.component.html'
})
export class SearchInputDropdownComponent {

  @Input('label')
  public label: string = '';

  @Input('placeholder')
  public placeholder: string = '';

  @Input('isLoading')
  public isLoading: boolean = false;

  @Input('data')
  public data: any[] = [];

  @Input('displayNameProp')
  public displayNameProp: string = '';

 @Output('onEnter') 
  public onEnter: EventEmitter<string> = new EventEmitter();

  @Output('onDebounce')
  public onDebounce: EventEmitter<string> = new EventEmitter();

  @Output('onSelected')
  public onSelected: EventEmitter<any> = new EventEmitter();

  public debouncer: Subject<string> = new Subject();

  public search: string = '';

  public searched: boolean = true;

  ngOnInit(): void {
    this.debouncer
      .pipe(debounceTime(300))
      .subscribe( value => this.onDebounce.emit(value));
  }

  /**
   * Reset the searched state and emit the search value through the debouncer.
   */
  public onKeyPress() {
    this.searched = false;
    this.debouncer.next(this.search);
  }

  /**
   * Emit element to search.
   */
  public onSearch() {
    this.searched = true;
    this.onEnter.emit(this.search);
  }

  /**
   * Clear textbox.
   */
  public onClearField() {
    this.search = '';
    this.onSearch();
  }

  /**
   * Emit a event when an element is selected.
   * @param value Element.
   */
  public onSelectedRecord(value: any) {
    this.onSelected.emit(value);
  }
}